import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StoreDetailService } from './resolver/store-detail.service';
import { LocalStorageService } from './storage/local-storage.service';
import { LocalStorageVariables } from '../enum/localstorage-variables';

// Declare dataLayer globally only in browser environment
declare const dataLayer: any;

function gtag(...args: any[]) {
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push(args);
  }
}
interface CookieConfigs {
  isConfirmed: boolean;
  analytics: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  private storeDetailService = inject(StoreDetailService);
  private localStorage = inject(LocalStorageService);
  private platformId = inject(PLATFORM_ID);

  isConfirmed: boolean = false;
  gtagObj = {
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    ad_storage: 'granted',
    analytics_storage: 'granted'
  };
  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      // Initialize dataLayer only in browser
      if (typeof window !== 'undefined') {
        (window as any).dataLayer = (window as any).dataLayer || [];
      }
    }

    if (this.cookieConfigs) {
      this.isConfirmed = this.cookieConfigs.isConfirmed;
      this.cookieConfigs.analytics
        ? this.enableGoogleAnalytics()
        : this.disableGoogleAnalytics();
    }
  }

  enableGoogleAnalytics(): void {
    this.toggleAnalytics(false);
  }

  disableGoogleAnalytics(): void {
    this.toggleAnalytics(true);
  }

  saveConfig(config: CookieConfigs, reload?: boolean) {
    this.cookieConfigs = config;
    this.deleteAllCookies();
    if (
      reload &&
      isPlatformBrowser(this.platformId) &&
      typeof window !== 'undefined'
    ) {
      window.location.reload();
    }
  }

  updateConsent() {
    this.localStorage.setItem(LocalStorageVariables.consent_granted, 'true');
    gtag('consent', 'update', {
      ...this.gtagObj
    });
  }

  private toggleAnalytics(disable: boolean) {
    this.gtagObj.analytics_storage = disable ? 'denied' : 'granted';
    this.updateConsent();
    const analyticsMeasurementID =
      this.storeDetailService?.permissionInit?.firebase_config?.measurementId;
    if (
      analyticsMeasurementID &&
      isPlatformBrowser(this.platformId) &&
      typeof window !== 'undefined'
    ) {
      window[`ga-disable-${analyticsMeasurementID}`] = disable;
    }
  }

  private get cookieConfigs(): CookieConfigs {
    return this.localStorage.getItem(LocalStorageVariables.cookie_store_key);
  }

  private set cookieConfigs(configs: CookieConfigs) {
    this.localStorage.setItem(LocalStorageVariables.cookie_store_key, configs);
    this.isConfirmed = configs.isConfirmed;
  }

  private deleteAllCookies() {
    if (
      !isPlatformBrowser(this.platformId) ||
      typeof document === 'undefined'
    ) {
      return;
    }

    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }
  }

  toggleAds(isGranted: boolean) {
    this.gtagObj.ad_personalization = isGranted ? 'granted' : 'denied';
    this.gtagObj.ad_storage = isGranted ? 'granted' : 'denied';
    this.gtagObj.ad_user_data = isGranted ? 'granted' : 'denied';
    this.updateConsent();
  }
}
